/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Dominik Boeck <d.boeck@techdivision.com>
 */

/**
 * ErrorBoundaryRender Component
 * We need this functional error boundary component to have the router functionality available
 *
 * @param fallback
 * @param error
 * @param setError
 * @param children
 * @returns {*}
 * @constructor
 */
export function ErrorBoundaryRender({ fallback, error, children }) {
  if (error) {
    return fallback;
  }
  return children;
}
